import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CloseConfirmDialog = ({ open, onKeepEditing, onConfirmClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onKeepEditing}>
      <DialogTitle>{t('varausModal.components.close')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('varausModal.components.closeConfirmation')}
        </Typography>
      </DialogContent>
      <Box sx={{ display: 'flex', gap: 1, p: 2, justifyContent: 'flex-end' }}>
        <Button onClick={onKeepEditing}>{t('varausModal.components.continue')}</Button>
        <Button onClick={onConfirmClose} color="error" variant="contained">
          {t('varausModal.close')}
        </Button>
      </Box>
    </Dialog>
  );
};

export default CloseConfirmDialog;
